import React, { Component } from 'react';
import { Badge, Button, Col, Icon, Row } from 'antd';
import className from 'classnames';

import Autocomplete from 'react-autocomplete';

export default class extends Component {
  state = {
    active: false,
    selectedAssign: '',
    selectedAssignKey: null
  }

  componentDidMount () {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount () {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClick = () => {
    this.setState({
      active: !this.state.active,
      selectedAssign: '',
      selectedAssignKey: null
    })
  }

  setWrapperRef = (node) => {
    this.wrapperRef = node
  }

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({
        active: false,
        selectedAssign: '',
        selectedAssignKey: null
      })
    }
  }

  assignUserOrGroup = () => {
    const { channelId, addGroups, addUsers } = this.props
    const id = this.state.selectedAssignKey.split('-')[0]
    const type = this.state.selectedAssignKey.split('-')[1]

    if (type === 'group') {
      addGroups(channelId, [id]).then(() => {
        this.setState({
          selectedAssign: '',
          selectedAssignKey: null
        })
      })
    } else if (type === 'user') {
      addUsers(channelId, [id]).then(() => {
        this.setState({
          selectedAssign: '',
          selectedAssignKey: null
        })
      })
    }
  }

  deleteUserOrGroup = (id, type) => {
    const { channelId, deleteGroups, deleteUsers } = this.props

    if (type === 'group') {
      deleteGroups(channelId, [id]).then(() => {
        this.setState({
          selectedAssign: '',
          selectedAssignKey: null
        })
      })
    } else if (type === 'user') {
      deleteUsers(channelId, [id]).then(() => {
        this.setState({
          selectedAssign: '',
          selectedAssignKey: null
        })
      })
    }
  }

  handleDropdown = () => {
    this.setState({
      dropdown: !this.state.dropdown
    })
  }

  render () {
    const { assign, assigned } = this.props
    const { active } = this.state

    return (
      <div ref={this.setWrapperRef} className='table-header__control table-header__control_last'>
        <Button style={{ marginLeft: 8 }} onClick={this.handleClick}>
          Users <Badge count={assigned.length > 0 ? assigned.map(item => item.count).reduce((a, b) => a + b) : null} style={{ backgroundColor: '#fff', color: '#999', boxShadow: '0 0 0 1px #d9d9d9 inset' }} /> <Icon type='down' />
        </Button>
        <div className={className('assign-dropdown', 'assign-dropdown-absolute', { '__active': active })}>
          <div className='assign-dropdown__heading'>
            Assign channel users
          </div>
          <div className='assign-dropdown__content'>
            <Row>
              <Col span={16}>
                <div className='autocomplete'>
                  <Autocomplete
                    getItemValue={(item) => item.name}
                    items={assign}

                    renderMenu={(items, value, style) =>
                      <div style={{ position: 'absolute', top: 'calc(100% + .2rem)', left: 0, right: 0, borderRadius: '.4rem', overflowY: 'auto', maxHeight: '15rem', background: '#fff', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)' }} children={items} />
                    }

                    renderItem={(item, isHighlighted) =>
                      <div key={`${item.id}${item.name}${item.type}`}
                           style={{
                             padding: '.4rem 1rem',
                             background: isHighlighted ? 'rgba(104, 70, 227, 0.1)' : '#fff'
                           }}>
                        {item.name}
                      </div>
                    }
                    value={this.state.selectedAssign}
                    onChange={(e) => this.setState({
                      selectedAssign: e.target.value,
                      selectedAssignKey: null
                    })}
                    onSelect={(val, item) => this.setState({
                      selectedAssign: item.name,
                      selectedAssignKey: item.key
                    })}
                    shouldItemRender={(item, value) => item.name.toLowerCase().indexOf(value.toLowerCase()) > -1}
                  />
                </div>
              </Col>
              <Col span={6}>
                <Button style={{ width: '100%', marginLeft: '1rem' }} type='indigo' onClick={this.assignUserOrGroup} disabled={!this.state.selectedAssignKey}>Add</Button>
              </Col>
            </Row>

            { assigned.length > 0
              ? <div className='assign-dropdown' style={{ marginTop: '1rem' }} >
                <div className='assign-dropdown__heading'>
                  Added users
                </div>
                <div className='assign-dropdown__content'>
                  <div className='assigned-list'>
                    { assigned.map((assign, index) =>
                      <div key={index} className='assigned-list__item'>
                        <div className='assigned-list__info'>
                          <div className='assigned-list__icon'>{assign.type === 'user' ? <Icon type='user' /> : <Icon type='usergroup-delete' /> }</div>
                          <div className='assigned-list__name'>{assign.name}</div>
                        </div>
                        <div className='assigned-list__delete' onClick={() => this.deleteUserOrGroup(assign.id, assign.type)}><Icon type='close' /></div>
                      </div>) }
                  </div>
                </div>
              </div> : null }
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Channels/components/UsersDropdown/UsersDropdown.jsx